export const images = {
    brandLogo: '/images/logo.jpg',
  };